import { NgModule } from '@angular/core';
import { DateOnlyFormatDirective } from './date-only-format.directive';

@NgModule({
  declarations: [DateOnlyFormatDirective],
  exports: [DateOnlyFormatDirective],
})
export class DateOnlyFormatModule {}
